export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f267e46bef018f5a93f0b86440da3f2202175703e&name=fetchTypeahead!'